import { call, put, takeLatest, select } from 'redux-saga/effects';
import reportApi from 'constants/reportApi';
import {
  SG_GET_STAFF_REPORTS,
  GET_STAFF_REPORTS,
  SG_PREGENERATE_STAFF_REPORT,
  PREGENERATE_STAFF_REPORT,
  SG_GET_STAFF_CACHE_STATUS,
  GET_STAFF_CACHE_STATUS,
  SG_INVALIDATE_STAFF_CACHE,
  INVALIDATE_STAFF_CACHE,
  SG_GET_STAFF_ACCESS_LOGS,
  GET_STAFF_ACCESS_LOGS,
  STAFF_REPORTS_PENDING,
  STAFF_REPORTS_OPERATION_SUCCESS,
  STAFF_REPORTS_OPERATION_ERROR,
} from 'constants/actions';

export function* loadStaffReports(action) {
  try {
    yield put({ type: STAFF_REPORTS_PENDING });
    // action.payload expected to be a query string
    const json = yield call(reportApi.LIST_STAFF_CACHED_REPORTS, action.payload);
    yield put({ type: GET_STAFF_REPORTS, payload: json.data });
    yield put({ type: STAFF_REPORTS_OPERATION_SUCCESS, payload: { op: 'LIST', data: json.data } });
  } catch (e) {
    yield put({ type: STAFF_REPORTS_OPERATION_ERROR, payload: { op: 'LIST', error: e } });
    yield put({ type: 'ALL_ERRORS', payload: e });
  }
}

export function* preGenerateReport(action) {
  try {
    yield put({ type: STAFF_REPORTS_PENDING });
    const json = yield call(reportApi.PREGENERATE_STAFF_REPORT, action.payload);
    yield put({ type: PREGENERATE_STAFF_REPORT, payload: json.data });
    yield put({ type: STAFF_REPORTS_OPERATION_SUCCESS, payload: { op: 'PREGENERATE', data: json.data } });
    // refresh the list so new row shows up
    try {
      const s = yield select((st) => st.staff_reports || {});
      const page = s.pageNumber || 1;
      const base = s.queryParams || '';
      const q = [`page=${page}`, `page_size=20`, base].filter(Boolean).join('&');
      yield put({ type: SG_GET_STAFF_REPORTS, payload: q });
    } catch (e) {
      // ignore select/refresh failures - not critical
    }
  } catch (e) {
    yield put({ type: STAFF_REPORTS_OPERATION_ERROR, payload: { op: 'PREGENERATE', error: e } });
    yield put({ type: 'ALL_ERRORS', payload: e });
  }
}

export function* checkCacheStatus(action) {
  try {
    yield put({ type: STAFF_REPORTS_PENDING });
    const json = yield call(reportApi.GET_STAFF_CACHE_STATUS, action.payload);
    yield put({ type: GET_STAFF_CACHE_STATUS, payload: json.data });
    yield put({ type: STAFF_REPORTS_OPERATION_SUCCESS, payload: { op: 'CACHE_STATUS', data: json.data } });
  } catch (e) {
    yield put({ type: STAFF_REPORTS_OPERATION_ERROR, payload: { op: 'CACHE_STATUS', error: e } });
    yield put({ type: 'ALL_ERRORS', payload: e });
  }
}

export function* invalidateCache(action) {
  try {
    yield put({ type: STAFF_REPORTS_PENDING });
    const json = yield call(reportApi.INVALIDATE_STAFF_CACHE, action.payload);
    yield put({ type: INVALIDATE_STAFF_CACHE, payload: json.data });
    yield put({ type: STAFF_REPORTS_OPERATION_SUCCESS, payload: { op: 'INVALIDATE', data: json.data } });
  } catch (e) {
    yield put({ type: STAFF_REPORTS_OPERATION_ERROR, payload: { op: 'INVALIDATE', error: e } });
    yield put({ type: 'ALL_ERRORS', payload: e });
  }
}

export function* getAccessLogs(action) {
  try {
    yield put({ type: STAFF_REPORTS_PENDING });
    // action.payload expected { id, query }
    const json = yield call(reportApi.GET_STAFF_ACCESS_LOGS, action.payload);
    yield put({ type: GET_STAFF_ACCESS_LOGS, payload: json.data });
    yield put({ type: STAFF_REPORTS_OPERATION_SUCCESS, payload: { op: 'ACCESS_LOGS', data: json.data } });
  } catch (e) {
    yield put({ type: STAFF_REPORTS_OPERATION_ERROR, payload: { op: 'ACCESS_LOGS', error: e } });
    yield put({ type: 'ALL_ERRORS', payload: e });
  }
}

export default function* staffReportsSaga() {
  yield takeLatest(SG_GET_STAFF_REPORTS, loadStaffReports);
  yield takeLatest(SG_PREGENERATE_STAFF_REPORT, preGenerateReport);
  yield takeLatest(SG_GET_STAFF_CACHE_STATUS, checkCacheStatus);
  yield takeLatest(SG_INVALIDATE_STAFF_CACHE, invalidateCache);
  yield takeLatest(SG_GET_STAFF_ACCESS_LOGS, getAccessLogs);
}
